import { DevelopmentalData } from "@/types/developmental";

export const age1Milestones: DevelopmentalData = {
  motor: [
    "Walks independently",
    "Begins to run",
    "Climbs stairs with support",
    "Throws and kicks balls",
    "Scribbles with crayons"
  ],
  language: [
    "Uses 10-20 words",
    "Follows simple commands",
    "Points to objects when named",
    "Begins to form two-word phrases",
    "Names familiar objects"
  ],
  cognitive: [
    "Sorts objects by shape and color",
    "Completes simple puzzles",
    "Understands cause and effect",
    "Imitates complex actions",
    "Shows interest in pretend play"
  ],
  independent: [
    "Feeds self with spoon",
    "Helps with dressing",
    "Removes some clothing",
    "Drinks from a cup",
    "Shows interest in toilet training"
  ],
  social: [
    "Plays alongside other children",
    "Shows increasing independence",
    "Expresses various emotions",
    "Responds to others' emotions",
    "Enjoys simple pretend play"
  ]
};